// extracted by mini-css-extract-plugin
module.exports = {"container":"FavoriteSection_container__qYUQI","slotBG":"FavoriteSection_slotBG__I4YDy"};